import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  tr: {
    // Nav / common
    "nav.ferry": "Feribot", "nav.hotel": "Otel", "nav.tour": "Tur", "nav.car": "Araç",
    "nav.visa": "Vize", "nav.campaigns": "Kampanyalar",
    "auth.login": "Giriş", "auth.register": "Üye Ol", "auth.logout": "Çıkış",
    "auth.profile": "Profil", "auth.admin": "Admin",
    "call.center": "Çağrı Merkezi",
    "common.search": "Ara", "common.book": "Rezerve Et", "common.select": "Seç",
    "common.back": "Geri", "common.next": "İleri", "common.save": "Kaydet",
    "common.cancel": "İptal", "common.loading": "Yükleniyor…", "common.download": "PDF İndir",
    // Search
    "search.from": "Nereden", "search.to": "Nereye", "search.date": "Gidiş Tarihi",
    "search.passengers": "Yolcular", "search.searchFerry": "Sefer Ara",
    "search.searchHotel": "Otel Ara", "search.searchTour": "Tur Ara",
    "search.searchCar": "Araçları Gör", "search.searchVisa": "Vize Tipleri",
    "search.island": "Ada / Destinasyon",
    // Hero
    "hero.kicker": "Türkiye → Yunan Adaları • İtalya • Kıbrıs",
    "hero.titleA": "Adalarda Tatil –", "hero.titleB": "Yunan Adaları", "hero.titleC": "Feribot, Otel ve Tur Paketleri",
    "hero.sub": "Türkiye'den Yunan Adaları'na feribot bileti, otel, tur, araç kiralama ve vize hizmetleri. En iyi fiyat garantisi, esnek tarihler, online iptal.",
    // Sections
    "sec.destinations": "Popüler Destinasyonlar",
    "sec.destinationsTitle": "Akdeniz'in en güzel on iki adası — kapında.",
    "sec.allDestinations": "Tüm Adaları Keşfet →",
    "sec.campaigns": "Aktif Kampanyalar", "sec.weekFeatured": "Bu hafta öne çıkanlar",
    "sec.services": "Hizmetlerimiz",
    "sec.servicesTitle": "Tatilin her parçası Adalardatatil'de.",
    // Trust
    "trust.bestPrice": "En İyi Fiyat Garantisi", "trust.bestPriceSub": "Özel anlaşma fiyatları",
    "trust.fastBuy": "2 Dakikada Biletini Al", "trust.fastBuySub": "Tek tıkla rezervasyon",
    "trust.securePay": "Güvenli Ödeme", "trust.securePaySub": "3D Secure korumalı",
    "trust.loyalty": "FL Puan & Yanmaz Bilet", "trust.loyaltySub": "Esnek değişiklik",
    // Footer
    "footer.tagline": "Türkiye'den Yunan Adaları'na — feribot, otel, tur, araç ve vize için tek adres. En iyi fiyat garantisi, 2 dakikada bilet.",
    "footer.popular": "Popüler Adalar", "footer.services": "Hizmetler",
    "footer.contact": "İletişim", "footer.support": "7/24 destek hattı",
    "footer.privacy": "Gizlilik", "footer.terms": "Kullanım Şartları", "footer.rights": "Tüm hakları saklıdır",
    // Profile
    "profile.welcome": "Hoş geldin", "profile.flPoints": "FL Puan",
    "profile.myBookings": "Biletlerim & Rezervasyonlarım",
    "profile.noBookings": "Henüz rezervasyonun yok.",
    "profile.total": "Toplam",
    // Booking
    "book.title": "Rezervasyon", "book.passengerInfo": "Yolcu Bilgileri",
    "book.contact": "İletişim", "book.payment": "Ödeme",
    "book.continueToPayment": "Ödemeye Devam Et →",
    "book.payNow": "Ödemeyi Tamamla", "book.processing": "İşleniyor…",
    "book.confirmed": "Rezervasyon Onaylandı",
    "book.pnr": "PNR / Bilet No", "book.earnedPoints": "FL Puan kazandın.",
    "book.myTickets": "Biletlerim", "book.home": "Anasayfa",
    "book.demoNote": "Demo modda ödeme simüle edilir. iyzico / PayTR canlı ödeme entegrasyonu, API anahtarları sağlandığında devreye alınacaktır.",
    "book.summary": "Özet", "book.trip": "Sefer", "book.departure": "Kalkış",
    // Verify
    "verify.title": "Bilet Doğrulama", "verify.valid": "Geçerli Bilet",
    "verify.invalid": "Geçersiz veya bulunamadı",
    "verify.status": "Durum", "verify.module": "Tür",
  },
  en: {
    "nav.ferry": "Ferry", "nav.hotel": "Hotel", "nav.tour": "Tour", "nav.car": "Car",
    "nav.visa": "Visa", "nav.campaigns": "Offers",
    "auth.login": "Sign In", "auth.register": "Sign Up", "auth.logout": "Sign Out",
    "auth.profile": "Profile", "auth.admin": "Admin",
    "call.center": "Call Center",
    "common.search": "Search", "common.book": "Book", "common.select": "Select",
    "common.back": "Back", "common.next": "Next", "common.save": "Save",
    "common.cancel": "Cancel", "common.loading": "Loading…", "common.download": "Download PDF",
    "search.from": "From", "search.to": "To", "search.date": "Departure",
    "search.passengers": "Passengers", "search.searchFerry": "Search Trips",
    "search.searchHotel": "Search Hotels", "search.searchTour": "Search Tours",
    "search.searchCar": "View Cars", "search.searchVisa": "Visa Types",
    "search.island": "Island / Destination",
    "hero.kicker": "Türkiye → Greek Islands • Italy • Cyprus",
    "hero.titleA": "A single ticket", "hero.titleB": "to the calm blue", "hero.titleC": "of the Aegean — in two minutes.",
    "hero.sub": "All operators in one place. Best price guarantee, flexible dates, online cancellation — from Chios to Santorini, Kos to Mykonos.",
    "sec.destinations": "Popular Destinations",
    "sec.destinationsTitle": "The twelve most beautiful islands of the Aegean — at your doorstep.",
    "sec.allDestinations": "Explore all islands →",
    "sec.campaigns": "Active Offers", "sec.weekFeatured": "Featured this week",
    "sec.services": "Our Services",
    "sec.servicesTitle": "Every part of your holiday — on Adalardatatil.",
    "trust.bestPrice": "Best Price Guarantee", "trust.bestPriceSub": "Exclusive partner rates",
    "trust.fastBuy": "Ticket in 2 minutes", "trust.fastBuySub": "One-click booking",
    "trust.securePay": "Secure Payment", "trust.securePaySub": "3D Secure protected",
    "trust.loyalty": "FL Points & Flexible Ticket", "trust.loyaltySub": "Easy changes",
    "footer.tagline": "From Türkiye to the Greek Islands — ferry, hotel, tour, car and visa in one place. Best price guarantee, 2-minute booking.",
    "footer.popular": "Popular Islands", "footer.services": "Services",
    "footer.contact": "Contact", "footer.support": "24/7 support",
    "footer.privacy": "Privacy", "footer.terms": "Terms", "footer.rights": "All rights reserved",
    "profile.welcome": "Welcome", "profile.flPoints": "FL Points",
    "profile.myBookings": "My Tickets & Bookings",
    "profile.noBookings": "No bookings yet.",
    "profile.total": "Total",
    "book.title": "Booking", "book.passengerInfo": "Passenger Details",
    "book.contact": "Contact", "book.payment": "Payment",
    "book.continueToPayment": "Continue to Payment →",
    "book.payNow": "Complete Payment", "book.processing": "Processing…",
    "book.confirmed": "Booking Confirmed",
    "book.pnr": "PNR / Ticket No", "book.earnedPoints": "FL Points earned.",
    "book.myTickets": "My Tickets", "book.home": "Home",
    "book.demoNote": "Demo mode — payment is simulated. iyzico / PayTR will be enabled once API keys are provided.",
    "book.summary": "Summary", "book.trip": "Trip", "book.departure": "Departure",
    "verify.title": "Ticket Verification", "verify.valid": "Valid Ticket",
    "verify.invalid": "Invalid or not found",
    "verify.status": "Status", "verify.module": "Type",
  },
  el: {
    "nav.ferry": "Πλοίο", "nav.hotel": "Ξενοδοχείο", "nav.tour": "Εκδρομή", "nav.car": "Αυτοκίνητο",
    "nav.visa": "Βίζα", "nav.campaigns": "Προσφορές",
    "auth.login": "Σύνδεση", "auth.register": "Εγγραφή", "auth.logout": "Έξοδος",
    "auth.profile": "Προφίλ", "auth.admin": "Διαχείριση",
    "call.center": "Τηλ. Κέντρο",
    "common.search": "Αναζήτηση", "common.book": "Κράτηση", "common.select": "Επιλογή",
    "common.back": "Πίσω", "common.next": "Επόμενο", "common.save": "Αποθήκευση",
    "common.cancel": "Άκυρο", "common.loading": "Φόρτωση…", "common.download": "Λήψη PDF",
    "search.from": "Από", "search.to": "Προς", "search.date": "Αναχώρηση",
    "search.passengers": "Επιβάτες", "search.searchFerry": "Αναζήτηση Δρομολογίων",
    "search.searchHotel": "Αναζήτηση Ξενοδοχείων", "search.searchTour": "Αναζήτηση Εκδρομών",
    "search.searchCar": "Δες Οχήματα", "search.searchVisa": "Τύποι Βίζας",
    "search.island": "Νησί / Προορισμός",
    "hero.kicker": "Τουρκία → Ελληνικά Νησιά • Ιταλία • Κύπρος",
    "hero.titleA": "Ένα εισιτήριο", "hero.titleB": "στο γαλήνιο γαλάζιο", "hero.titleC": "του Αιγαίου — σε δύο λεπτά.",
    "hero.sub": "Όλοι οι μεταφορείς σε ένα μέρος. Εγγύηση χαμηλότερης τιμής, ευέλικτες ημερομηνίες, online ακύρωση.",
    "sec.destinations": "Δημοφιλείς Προορισμοί",
    "sec.destinationsTitle": "Τα δώδεκα ομορφότερα νησιά του Αιγαίου — δίπλα σας.",
    "sec.allDestinations": "Όλα τα νησιά →",
    "sec.campaigns": "Ενεργές Προσφορές", "sec.weekFeatured": "Επιλογές της εβδομάδας",
    "sec.services": "Υπηρεσίες",
    "sec.servicesTitle": "Κάθε κομμάτι των διακοπών — στο Adalardatatil.",
    "trust.bestPrice": "Εγγύηση Καλύτερης Τιμής", "trust.bestPriceSub": "Αποκλειστικές τιμές",
    "trust.fastBuy": "Εισιτήριο σε 2 λεπτά", "trust.fastBuySub": "Κράτηση με ένα κλικ",
    "trust.securePay": "Ασφαλής Πληρωμή", "trust.securePaySub": "Με προστασία 3D Secure",
    "trust.loyalty": "Πόντοι FL & Ευέλικτο Εισιτήριο", "trust.loyaltySub": "Εύκολες αλλαγές",
    "footer.tagline": "Από την Τουρκία στα ελληνικά νησιά — πλοίο, ξενοδοχείο, εκδρομή, αυτοκίνητο και βίζα σε ένα σημείο.",
    "footer.popular": "Δημοφιλή Νησιά", "footer.services": "Υπηρεσίες",
    "footer.contact": "Επικοινωνία", "footer.support": "Υποστήριξη 24/7",
    "footer.privacy": "Απόρρητο", "footer.terms": "Όροι", "footer.rights": "Όλα τα δικαιώματα διατηρούνται",
    "profile.welcome": "Καλώς ήρθες", "profile.flPoints": "Πόντοι FL",
    "profile.myBookings": "Τα Εισιτήριά μου",
    "profile.noBookings": "Δεν υπάρχουν κρατήσεις.",
    "profile.total": "Σύνολο",
    "book.title": "Κράτηση", "book.passengerInfo": "Στοιχεία Επιβάτη",
    "book.contact": "Επικοινωνία", "book.payment": "Πληρωμή",
    "book.continueToPayment": "Συνέχεια στην Πληρωμή →",
    "book.payNow": "Ολοκλήρωση Πληρωμής", "book.processing": "Επεξεργασία…",
    "book.confirmed": "Επιβεβαιωμένη Κράτηση",
    "book.pnr": "PNR / Αριθμός", "book.earnedPoints": "Πόντοι FL κερδίστηκαν.",
    "book.myTickets": "Εισιτήρια", "book.home": "Αρχική",
    "book.demoNote": "Λειτουργία demo — η πληρωμή είναι προσομοιωμένη.",
    "book.summary": "Σύνοψη", "book.trip": "Δρομολόγιο", "book.departure": "Αναχώρηση",
    "verify.title": "Επαλήθευση Εισιτηρίου", "verify.valid": "Έγκυρο Εισιτήριο",
    "verify.invalid": "Μη έγκυρο ή δεν βρέθηκε",
    "verify.status": "Κατάσταση", "verify.module": "Τύπος",
  },
  de: {
    "nav.ferry": "Fähre", "nav.hotel": "Hotel", "nav.tour": "Tour", "nav.car": "Auto",
    "nav.visa": "Visum", "nav.campaigns": "Angebote",
    "auth.login": "Anmelden", "auth.register": "Registrieren", "auth.logout": "Abmelden",
    "auth.profile": "Profil", "auth.admin": "Admin",
    "call.center": "Servicecenter",
    "common.search": "Suchen", "common.book": "Buchen", "common.select": "Auswählen",
    "common.back": "Zurück", "common.next": "Weiter", "common.save": "Speichern",
    "common.cancel": "Abbrechen", "common.loading": "Lädt…", "common.download": "PDF herunterladen",
    "search.from": "Von", "search.to": "Nach", "search.date": "Abfahrt",
    "search.passengers": "Reisende", "search.searchFerry": "Fähren suchen",
    "search.searchHotel": "Hotels suchen", "search.searchTour": "Touren suchen",
    "search.searchCar": "Fahrzeuge ansehen", "search.searchVisa": "Visum-Arten",
    "search.island": "Insel / Reiseziel",
    "hero.kicker": "Türkei → Griechische Inseln • Italien • Zypern",
    "hero.titleA": "Ein Ticket", "hero.titleB": "ins stille Blau", "hero.titleC": "der Ägäis — in zwei Minuten.",
    "hero.sub": "Alle Anbieter an einem Ort. Bestpreisgarantie, flexible Daten, Online-Stornierung.",
    "sec.destinations": "Beliebte Ziele",
    "sec.destinationsTitle": "Die zwölf schönsten Inseln der Ägäis — vor Ihrer Tür.",
    "sec.allDestinations": "Alle Inseln entdecken →",
    "sec.campaigns": "Aktuelle Angebote", "sec.weekFeatured": "Diese Woche im Fokus",
    "sec.services": "Unsere Leistungen",
    "sec.servicesTitle": "Jeder Teil Ihres Urlaubs — auf Adalardatatil.",
    "trust.bestPrice": "Bestpreisgarantie", "trust.bestPriceSub": "Exklusive Partnertarife",
    "trust.fastBuy": "Ticket in 2 Minuten", "trust.fastBuySub": "One-Click-Buchung",
    "trust.securePay": "Sichere Zahlung", "trust.securePaySub": "3D-Secure geschützt",
    "trust.loyalty": "FL-Punkte & flexibles Ticket", "trust.loyaltySub": "Einfache Änderung",
    "footer.tagline": "Von der Türkei zu den griechischen Inseln — Fähre, Hotel, Tour, Auto und Visum an einem Ort.",
    "footer.popular": "Beliebte Inseln", "footer.services": "Leistungen",
    "footer.contact": "Kontakt", "footer.support": "24/7 Support",
    "footer.privacy": "Datenschutz", "footer.terms": "AGB", "footer.rights": "Alle Rechte vorbehalten",
    "profile.welcome": "Willkommen", "profile.flPoints": "FL Punkte",
    "profile.myBookings": "Meine Tickets & Buchungen",
    "profile.noBookings": "Noch keine Buchungen.",
    "profile.total": "Gesamt",
    "book.title": "Buchung", "book.passengerInfo": "Reisedaten",
    "book.contact": "Kontakt", "book.payment": "Zahlung",
    "book.continueToPayment": "Weiter zur Zahlung →",
    "book.payNow": "Zahlung abschließen", "book.processing": "Wird verarbeitet…",
    "book.confirmed": "Buchung bestätigt",
    "book.pnr": "PNR / Ticket-Nr", "book.earnedPoints": "FL-Punkte erhalten.",
    "book.myTickets": "Meine Tickets", "book.home": "Startseite",
    "book.demoNote": "Demo-Modus — Zahlung simuliert. iyzico / PayTR wird nach Erhalt der API-Schlüssel aktiviert.",
    "book.summary": "Zusammenfassung", "book.trip": "Fahrt", "book.departure": "Abfahrt",
    "verify.title": "Ticket-Überprüfung", "verify.valid": "Gültiges Ticket",
    "verify.invalid": "Ungültig oder nicht gefunden",
    "verify.status": "Status", "verify.module": "Typ",
  },
};

export const LANGS = [
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "en", label: "EN", name: "English" },
];

const I18nCtx = createContext({ lang: "tr", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "tr";
    const saved = localStorage.getItem("lang");
    return (saved === "tr" || saved === "en") ? saved : "tr";
  });
  useEffect(() => { if (typeof document !== "undefined") document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem("lang", l); } catch (err) { console.warn("lang persist failed", err); }
  };
  const t = (key) => DICT[lang]?.[key] ?? DICT.tr[key] ?? key;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useT = () => useContext(I18nCtx);
